<template>
  <div v-if="appointmentId && $store.state.address.google">
    <ul class="list-group overflow-y-auto mb-3" style="max-height: 300px">
      <li
        v-if="initialised && travels.length === 0"
        class="list-group-item highlight cursor text-center py-3"
      >
        No travel / check-in record yet
      </li>
      <template v-if="initialised">
        <li v-for="travel in travels" :key="travel.id" class="list-group-item highlight cursor">
          <div class="pb-1">
            <label class="font-weight-bold mb-0">Travel Start</label>
            {{ formatLocalDate(travel.begin_travel_at, "DD MMM YYYY@hh:mma") }}
          </div>
          <div>
            <label class="font-weight-bold mb-0">Travel End</label>
            {{ formatLocalDate(travel.end_travel_at, "DD MMM YYYY@hh:mma") }}
          </div>
        </li>
        <li v-for="checkIn in checkIns" :key="checkIn.id" class="list-group-item highlight cursor">
          <div class="pb-1">
            <label class="font-weight-bold mb-0">Check-In</label>
            {{ formatLocalDate(checkIn.checked_in_at, "DD MMM YYYY@hh:mma") }}
            <div
              v-if="checkIn.check_in_address"
              v-tooltip="{
                content: checkIn.check_in_address,
                classes: 'badge-theme',
              }"
              class="badge badge-large badge-info"
            >
              {{ checkIn.check_in_city }}
            </div>
          </div>
          <div>
            <label class="font-weight-bold mb-0">Check-Out</label>
            {{ formatLocalDate(checkIn.checked_out_at, "DD MMM YYYY@hh:mma") }}
            <div
              v-if="checkIn.check_out_address"
              v-tooltip="{
                content: checkIn.check_out_address,
                classes: 'badge-theme',
              }"
              class="badge badge-large badge-info"
            >
              {{ checkIn.check_out_city }}
            </div>
          </div>
        </li>
      </template>
      <li v-if="!initialised" class="list-group-item highlight cursor text-center py-3">
        <font-awesome-icon :icon="['fal', 'spinner']" spin />
        Loading...
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
import format from "../../../../mixins/format";

export default {
  mixins: [format],

  props: {
    appointmentId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      initialised: false,
      checkIns: [],
      travels: null,
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    getAddressObject(addressComponents) {
      const ShouldBeComponent = {
        home: ["street_number"],
        postal_code: ["postal_code"],
        street: ["street_address", "route"],
        region: [
          "administrative_area_level_1",
          "administrative_area_level_2",
          "administrative_area_level_3",
          "administrative_area_level_4",
          "administrative_area_level_5",
        ],
        city: [
          "locality",
          "sublocality",
          "sublocality_level_1",
          "sublocality_level_2",
          "sublocality_level_3",
          "sublocality_level_4",
        ],
        country: ["country"],
      };

      const address = {
        home: "",
        postal_code: "",
        street: "",
        region: "",
        city: "",
        country: "",
      };
      addressComponents.forEach((component) => {
        /* eslint-disable no-restricted-syntax */
        for (const shouldBe in ShouldBeComponent) {
          if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
            if (shouldBe === "country") {
              address[shouldBe] = component.short_name;
            } else {
              address[shouldBe] = component.long_name;
            }
          }
        }
      });

      const stateMap = {
        "Australian Capital Territory": "ACT",
        "New South Wales": "NSW",
        "Northern Territory": "NT",
        Queensland: "QLD",
        "South Australia": "SA",
        Tasmania: "TAS",
        Victoria: "VIC",
        "Western Australia": "WA",
      };

      address.short = [
        `${address.home} ${address.street}`.trim(),
        address.city,
        this.$lodash.get(stateMap, address.region),
      ].join(", ");

      return address;
    },

    async init() {
      this.checkIns = [];
      this.travels = [];

      const checkinResponse = await this.$http.get(
        `/appointments/${this.appointmentId}/check-ins?limit=999`
      );
      if (checkinResponse.status === 200) {
        this.checkIns = checkinResponse.body.data.map((checkInParameter) => {
          const checkIn = checkInParameter;

          checkIn.check_in_address = null;
          checkIn.check_in_city = "Unknown";
          checkIn.check_out_address = null;
          checkIn.check_out_city = "Unknown";

          return checkIn;
        });
      }

      const travelResponse = await this.$http.get(
        `/appointments/${this.appointmentId}/travels?limit=999`
      );
      if (travelResponse.status === 200) {
        this.travels = travelResponse.body.data;
      }

      this.initialised = true;
    },
  },
};
</script>
